var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvLgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7416_6300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7416_6300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -110,
    y: -222,
    width: 286,
    height: 390
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-109.512 -221.934H175.491V167.77H-109.512V-221.934Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7416_6300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99881 20C15.5224 20 20 15.5157 20 10.0012C20 4.4765 15.5224 -1.90735e-06 9.99881 -1.90735e-06C4.47584 -1.90735e-06 0 4.4765 0 10.0012C0 15.5157 4.47584 20 9.99881 20Z",
    fill: "#C4084F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59595 5.6067V14.3831H12.3811V13.5947H10.4012V5.6067H9.59595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80365 8.00601C7.46401 8.00601 8.00762 7.46964 8.00762 6.80756C8.00762 6.14189 7.46401 5.60432 6.80365 5.60432C6.14329 5.60432 5.60327 6.14189 5.60327 6.80756C5.60327 7.46964 6.14329 8.00601 6.80365 8.00601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4012 1.63664C10.2916 1.63365 10.1018 1.63365 9.99885 1.63365C5.38232 1.63365 1.62671 5.38103 1.62671 9.99941C1.62671 12.2329 2.4996 14.337 4.07596 15.9156C5.66011 17.4978 7.75734 18.3771 9.99885 18.3771C12.2356 18.3771 14.3358 17.4978 15.9187 15.9156C17.4951 14.337 18.3632 12.2329 18.3632 9.99941V9.61688H12.3888V10.3939H17.5705C17.5705 10.4095 17.567 10.4951 17.567 10.5124C17.3119 14.4639 14.0059 17.5828 9.99885 17.5828C7.97526 17.5828 6.06184 16.7974 4.63156 15.3685C3.19948 13.9365 2.4062 12.0263 2.4062 9.99881C2.4062 7.97306 3.19948 6.06645 4.63156 4.63515C6.06184 3.20025 7.97526 2.41006 9.99885 2.41006C10.0887 2.41006 10.3018 2.41486 10.4012 2.41665V1.63664Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7416_6300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvLgStore);
export default __webpack_public_path__ + "static/media/ctv_lg_store.f86555559d44c689a31d9664cc70c49a.svg";
export { ForwardRef as ReactComponent };